import React, { useState, useEffect, useCallback, memo } from "react";
import { Box, Grommet, Notification as NotificationAp,TextArea,Text,CheckBox,Layer,Button,DateInput,TextInput,FileInput,Tabs,Tab } from 'grommet';
import  { Redirect } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import moment from "moment";
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Divider } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import { Accordion,AccordionSummary,AccordionDetails,Typography  } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import FolderIcon from '@mui/icons-material/Folder';
import DownloadIcon from '@mui/icons-material/Download';
import { CircularProgress } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {useLazyQuery, useMutation} from "@apollo/client";
import {
    DELETE_TO_DO,
    GET_USER,
    QUERY_ARCHIVED_TO_DO,
    QUERY_ASSIGNED_TO_DO,
    QUERY_TO_DO,
    CHECK_TO_DO, ADD_USER_TO_DO_RELATION, UPDATE_TO_DO, ADD_TO_DO, DELETE_USER_TO_DO_RELATION, GET_TO_DO_ASSIGNED_USER
} from "./ToDoGQL.jsx";
import {tenant, tenantType} from "../tenant.js";
import {extractIdFormData, GOLF_ADD_ATTACHMENT, GOLF_GET_ATTACHMENT, QUERY_CONTENT_TYPE} from "../../utilis/utils.js";
import {AttachFile} from "@material-ui/icons";

// Componente Form Layer separato e memoizzato per evitare re-render della lista
const ToDoFormLayer = memo(({
  initialFormData,
  usersList,
  initialSelectedUser,
  contentType,
  onClose,
  onSave,
  elencoAllegatiProp
}) => {
  const [formData, setFormData] = useState(initialFormData || {});
  const [selectedUser, setSelectedUser] = useState(initialSelectedUser || []);
  const [elencoFile, setElencoFile] = useState([]);
  const [elencoAllegati] = useState(elencoAllegatiProp || []);
  const [checkNotifyNewNote, setCheckedNotifyNewNote] = useState(false);
  const [mostraLayerCaricatore, setMostraLayerCaricatore] = useState(false);

  // Aggiorna lo stato locale quando cambiano le props iniziali
  useEffect(() => {
    setFormData(initialFormData || {});
  }, [initialFormData]);

  useEffect(() => {
    setSelectedUser(initialSelectedUser || []);
  }, [initialSelectedUser]);

  const handleTitleChange = useCallback((event) => {
    const value = event.target.value;
    setFormData(prev => ({ ...prev, title: value }));
  }, []);

  const handleTextChange = useCallback((event) => {
    const value = event.target.value;
    setFormData(prev => ({ ...prev, text: value }));
  }, []);

  const handleDateChange = useCallback(({ value }) => {
    setFormData(prev => ({ ...prev, expiration: moment(value).format() }));
  }, []);

  const handleUserChange = useCallback((event, newValue) => {
    setSelectedUser(newValue);
  }, []);

  const handleFileChange = useCallback((event) => {
    const fileList = event.target.files;
    const file = fileList[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      const result = reader.result;
      const fileObj = {
        name: file.name,
        type: file.type,
        content: result,
        size: file.size,
        modified: file.lastModifiedDate,
      };
      setElencoFile(prev => [...prev, fileObj]);
    };
  }, []);

  const handleSave = useCallback(() => {
    // Assicura che i campi obbligatori abbiano un valore
    const dataToSave = {
      ...formData,
      title: formData.title || "",
      text: formData.text || ""
    };
    onSave(dataToSave, selectedUser, elencoFile, checkNotifyNewNote);
  }, [formData, selectedUser, elencoFile, onSave, checkNotifyNewNote]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const downloadFile = useCallback((allegatoSel) => {
    window.open("/media/" + allegatoSel.attachment);
  }, []);

  return (
    <Layer
      onEsc={handleClose}
      onClickOutside={handleClose}
    >
      <Box round width="600px" pad="medium" direction="column" background="white" overflow="auto" gap="medium" margin="10px">
        <Box flex={false}>
          <Text style={{ marginRight: '10px', marginTop: '-3px' }}>Seleziona la data di fine: *</Text>
          <DateInput
            format="dd/mm/yyyy"
            value={formData?.expiration || moment(new Date()).format()}
            onChange={handleDateChange}
            calendarProps={{ size: "small", locale: "it-IT", daysOfWeek: true, firstDayOfWeek: 1 }}
          />
        </Box>
        <Text style={{ marginRight: '10px', marginTop: '-3px' }}>Visibile da:</Text>
        <Autocomplete
          disableCloseOnSelect
          multiple
          disablePortal
          id="combo-box-demo"
          options={usersList}
          value={selectedUser}
          onChange={handleUserChange}
          getOptionLabel={(option) => option.name + " " + option.surname + " " + option.registration_number}
          renderInput={(params) => <TextField {...params} size="medium" variant="standard" />}
        />

        <TextInput
          placeholder="Inserisci titolo nota"
          value={formData?.title || ""}
          onChange={handleTitleChange}
        />

        <Box flex={false}>
          <TextArea
            value={formData?.text || ""}
            style={{ height: 180 }}
            resize={false}
            placeholder="Inserisci nota"
            onChange={handleTextChange}
          />
        </Box>

        {elencoAllegati.length > 0 && (
          <List dense={false}>
            {elencoAllegati.map((allegato, idx) => (
              <ListItem
                key={idx}
                secondaryAction={
                  <Box gap="small" direction="row">
                    <IconButton edge="end" aria-label="delete" onClick={() => downloadFile(allegato)}>
                      <DownloadIcon />
                    </IconButton>
                  </Box>
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    <FolderIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h6" style={allegato.name.length >= 50 ? { fontSize: "10px" } : { fontSize: "15px" }}>{allegato.name}</Typography>}
                />
              </ListItem>
            ))}
          </List>
        )}

        <FileInput
          multiple
          name="file"
          onChange={handleFileChange}
        />
        <FormControlLabel
          label="Ricevi notifica alla scadenza"
          control={
            <Checkbox
              checked={checkNotifyNewNote}
              onChange={(e) => setCheckedNotifyNewNote(e.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
        />
        <Box direction="row" alignSelf="center">
          <Button label={formData?.id ? "Aggiorna" : "Crea"} onClick={handleSave} style={{ width: '138px', height: '34px', fontSize: '15px', background: '#397aa3', color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }} />
          <Button type="reset" label="Chiudi" onClick={handleClose} style={{ marginLeft: '20px', height: '34px', width: '138px', fontSize: '15px', background: '#c51d34', color: 'white', fontWeight: 'bold', textTransform: 'uppercase', borderColor: '#c51d34' }} />
        </Box>
      </Box>
      {mostraLayerCaricatore && (
        <Layer onEsc={() => setMostraLayerCaricatore(false)} onClickOutside={() => setMostraLayerCaricatore(false)}>
          <Box align="center" gap="medium" pad="small">
            <CircularProgress style={{ 'color': 'green' }} variant="determinate" value={90} />
            <Text>Caricamento...</Text>
          </Box>
        </Layer>
      )}
    </Layer>
  );
});

// Componente singolo ToDo Item memoizzato
const ToDoItem = memo(({
  toDo,
  index,
  expanded,
  onExpandChange,
  onCheck,
  onEdit,
  onDelete,
  elencoFile,
  width
}) => {
  const downloadFile = useCallback((allegatoSel) => {
    window.open("/media/" + allegatoSel.attachment);
  }, []);

  return (
    <Accordion expanded={expanded === 'panel' + index} onChange={onExpandChange('panel' + index)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box direction="row" gap="small" width="100%">
          <CheckBox
            checked={toDo?.checked || false}
            label=""
            onChange={(event) => onCheck(toDo.id, event.target.checked)}
          />
          <Box direction="column" gap="small" width="100%">
            <Box direction="column">
              <Typography style={toDo?.checked ? { fontSize: "20px", textDecoration: "line-through" } : { fontSize: "20px" }} color={"black"}>TITOLO: {toDo.title}</Typography>
              <Typography size="medium" weight="bold" style={toDo?.checked ? { textDecoration: "line-through" } : null}>Mittente: {`${toDo[`users_user${tenantType}`].name} ${toDo[`users_user${tenantType}`].surname} ${toDo[`users_user${tenantType}`].registration_number}`}</Typography>
              <Typography size="medium" weight="bold" style={toDo?.checked ? { textDecoration: "line-through" } : null} color={toDo.expiration <= moment(new Date).format('YYYY-MM-DD') ? "red" : "black"}>Scadenza: {toDo.expiration}</Typography>
            </Box>
            <Box direction="row" gap="small">
              {toDo?.have_attachment && <AttachFile />}
              <Typography sx={toDo.checked ? { width: '100%', flexShrink: 0, fontWeight: 'bold', textDecoration: "line-through", wordWrap: "break-word" } : { width: '100%', flexShrink: 0, fontWeight: 'bold', wordWrap: "break-word" }} variant={width < 500 ? "h7" : "h5"}>{toDo.title}</Typography>
            </Box>
          </Box>
          <Box align="end" direction="row">
            <IconButton aria-label="edit" size="medium" onClick={() => onEdit(toDo)}>
              <EditIcon size="medium" color="primary" />
            </IconButton>
            <IconButton aria-label="delete" size="medium" onClick={() => onDelete(toDo.id)}>
              <DeleteIcon size="medium" color="primary" />
            </IconButton>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box direction="column" gap="small" flex={false}>
          <TextField
            InputProps={{ disableUnderline: true }}
            id="standard-textarea"
            placeholder="Placeholder"
            multiline
            variant="standard"
            value={toDo.text}
          />
          {elencoFile.length > 0 && (
            <List dense={false}>
              {elencoFile.map((allegato, idx) => (
                <ListItem
                  key={idx}
                  secondaryAction={
                    <Box gap="small" direction="row">
                      <IconButton edge="end" aria-label="delete" onClick={() => downloadFile(allegato)}>
                        <DownloadIcon />
                      </IconButton>
                    </Box>
                  }
                >
                  <ListItemAvatar>
                    <Avatar>
                      <FolderIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography variant="h6" style={allegato.name.length >= 50 ? { fontSize: "10px" } : { fontSize: "15px" }}>{allegato.name}</Typography>}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
});

// Componente lista memoizzato
const ToDoListContent = memo(({
  elencoToDo,
  expanded,
  onExpandChange,
  onCheck,
  onEdit,
  onDelete,
  onAccordionClick,
  elencoFile,
  width
}) => {
  if (elencoToDo.length === 0) {
    return (
      <Box align="center" alignSelf="center">
        <Text color="#397aa3" size="large" weight="bold" alignSelf="start">Non ci sono note al momento</Text>
      </Box>
    );
  }

  return (
    <Box overflow="auto" gap="small" margin="small">
      {elencoToDo.map((toDo, i) => (
        <Box key={toDo.id} onClick={() => onAccordionClick(toDo.id)}>
          <ToDoItem
            toDo={toDo}
            index={i}
            expanded={expanded}
            onExpandChange={onExpandChange}
            onCheck={onCheck}
            onEdit={onEdit}
            onDelete={onDelete}
            elencoFile={elencoFile}
            width={width}
          />
        </Box>
      ))}
    </Box>
  );
});

const theme = {
  global: {
    colors: {
      brand: '#397aa3',
      'accent-1': 'white',
      'focus': '#397aa3',
      "my-text-color": "",
      background: '#ecedf3',
    },
    font: {
      family: '',
      size: '18px',
      height: '20px',
    },
    menu:{
      icons:{
        color:'white',
        },
    },
  },
};

const ToDoListMain = (props) => {
  const [showLayer, setShowLayer] = useState(false);
  const [elencoToDo, setElencoToDo] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [elencoAllegati, setElencoAllegati] = useState([]);
  const [elencoFile, setElencoFile] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [index, setIndex] = useState(0);
  const [formData, setFormData] = useState({});
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [contentType, setContentType] = useState();

  const [addToDo] = useMutation(ADD_TO_DO);
  const [updateToDo] = useMutation(UPDATE_TO_DO);
  const [deleteToDo] = useMutation(DELETE_TO_DO);
  const [deleteUserToDoRelation] = useMutation(DELETE_USER_TO_DO_RELATION);
  const [addUserToDoRelation] = useMutation(ADD_USER_TO_DO_RELATION);
  const [addAttachment] = useMutation(GOLF_ADD_ATTACHMENT);
  const [checkToDo] = useMutation(CHECK_TO_DO);

  const [queryAllToDO] = useLazyQuery(QUERY_TO_DO, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const toDoList = data[`${tenant}_users_userstodo`].map((el) => el.users_todo);
      if (toDoList) {
        setElencoToDo(toDoList);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryAssignedToDO] = useLazyQuery(QUERY_ASSIGNED_TO_DO, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const toDoList = data[`${tenant}_users_userstodo`].map((el) => el.users_todo);
      if (toDoList) {
        setElencoToDo(toDoList);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryArchivedToDo] = useLazyQuery(QUERY_ARCHIVED_TO_DO, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const toDoList = data[`${tenant}_users_userstodo`].map((el) => el.users_todo);
      if (toDoList) {
        setElencoToDo(toDoList);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryUser] = useLazyQuery(GET_USER, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      let users = data[`${tenant}_users_userarea`].map((el) => el[`users_user${tenantType}`]).sort((a, b) => a.name.localeCompare(b.name));
      if (users) {
        setUsersList(users);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryGetAssignedUser] = useLazyQuery(GET_TO_DO_ASSIGNED_USER, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      let assignedUser = data[`${tenant}_users_userstodo`].map((el) => el[`users_user${tenantType}`]);
      if (assignedUser) {
        setSelectedUser(assignedUser);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryGetContentType] = useLazyQuery(QUERY_CONTENT_TYPE, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      let ct = data[`django_content_type`][0];
      if (ct) {
        setContentType(ct);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  const [queryGetAttachments] = useLazyQuery(GOLF_GET_ATTACHMENT, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const attachments = data[`${tenant}_attachments_attachment`];
      if (attachments) {
        setElencoFile(attachments);
      }
    },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    queryAllToDO({ variables: { userId: sessionStorage.getItem("userId") } });
    queryGetContentType({ variables: { model: "product" } });
  }, []);

  useEffect(() => {
    queryUser({ variables: { areeId: props.aree || JSON.parse(sessionStorage.getItem("areeId")) } });
  }, [props.aree]);

  useEffect(() => {
    const updateDimensions = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // Funzione filterToDo memoizzata
  const filterToDo = useCallback((idx) => {
    if (idx === 0) {
      queryAllToDO({ variables: { userId: sessionStorage.getItem("userId") } });
    } else if (idx === 1) {
      queryAssignedToDO({ variables: { userId: sessionStorage.getItem("userId") } });
    } else if (idx === 2) {
      queryArchivedToDo({ variables: { userId: sessionStorage.getItem("userId") } });
    }
  }, [queryAllToDO, queryAssignedToDO, queryArchivedToDo]);

  // Handler memoizzati per evitare re-render
  const handleExpandChange = useCallback((panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }, []);

  const handleCheck = useCallback((toDoId, checked) => {
    checkToDo({ variables: { id: toDoId, checked: checked } });
    filterToDo(index);
  }, [checkToDo, filterToDo, index]);

  const handleEdit = useCallback((toDo) => {
    setFormData({ ...toDo });
    queryGetAssignedUser({ variables: { toDoId: toDo.id } });
    queryGetAttachments({ variables: { contentTypeId: contentType?.id, objectId: toDo.id } });
    setShowLayer(true);
  }, [queryGetAssignedUser, queryGetAttachments, contentType]);

  const handleDelete = useCallback((toDoId) => {
    let result = window.confirm("Sicuro di voler eliminare la nota?");
    if (result) {
      deleteToDo({ variables: { id: toDoId } }).then(() => filterToDo(index));
    }
  }, [deleteToDo, filterToDo, index]);

  const handleAccordionClick = useCallback((toDoId) => {
    queryGetAttachments({ variables: { contentTypeId: contentType?.id, objectId: toDoId } });
  }, [queryGetAttachments, contentType]);

  const handleCloseLayer = useCallback(() => {
    setShowLayer(false);
    setFormData({});
    setSelectedUser([]);
  }, []);

  const handleSave = useCallback((formDataFromLayer, selectedUserFromLayer, elencoFileFromLayer, notifyOnExpire) => {
    let formDataApp = { ...formDataFromLayer };
    formDataApp["user_creator"] = usersList.find((el) => el.id == sessionStorage.getItem("userId"))?.id;
    let obj = extractIdFormData(formDataApp, true);
    obj.variables.haveAttachment = elencoFileFromLayer.length > 0;

    if (!formDataFromLayer?.id) {
      // Aggiungi campi obbligatori per nuovi ToDo
      obj.variables.createdAt = new Date().toISOString();
      obj.variables.notificationOnExpire = notifyOnExpire || false;
      obj.variables.notificationOnSave = false;
      obj.variables.checked = false;
      addToDo(obj)
        .then(async (value) => {
          const toDoId = value.data[`insert_${tenant}_users_todo_one`].id;
          const currentUserId = parseInt(sessionStorage.getItem("userId"));

          // Per nuovo ToDo, aggiungi relazione utente (creatore = assigned false)
          try {
            await addUserToDoRelation({ variables: { userId: currentUserId, toDoId: parseInt(toDoId), assigned: false } });
            console.log("Relazione utente creata:", { userId: currentUserId, toDoId: toDoId });
          } catch (err) {
            console.error("Errore creazione relazione utente:", err);
          }

          // Aggiungi relazioni per utenti selezionati (assigned = true)
          for (let i = 0; i < selectedUserFromLayer.length; i++) {
            try {
              await addUserToDoRelation({ variables: { userId: parseInt(selectedUserFromLayer[i].id), toDoId: parseInt(toDoId), assigned: true } });
            } catch (err) {
              console.error("Errore creazione relazione utente selezionato:", err);
            }
          }

          // Aggiungi allegati
          if (contentType && elencoFileFromLayer.length > 0) {
            for (let i = 0; i < elencoFileFromLayer.length; i++) {
              await addAttachment({ variables: { name: elencoFileFromLayer[i].name, contentType: contentType.id, objectId: toDoId, attachment: JSON.stringify(elencoFileFromLayer[i]) } });
            }
          }

          alert("Nota aggiunta correttamente");
          handleCloseLayer();
          filterToDo(index);
        })
        .catch((error) => {
          console.error(error);
          alert("Errore durante la creazione");
        });
    } else {
      obj.variables.userCreator = obj.variables["usersUser" + tenantType];
      delete obj.variables["usersUser" + tenantType];
      delete obj.variables._Typename;
      updateToDo(obj)
        .then(async (value) => {
          const toDoId = value.data[`update_${tenant}_users_todo_by_pk`].id;
          const currentUserId = parseInt(sessionStorage.getItem("userId"));

          // Prima elimina le relazioni esistenti, poi ricreale
          await deleteUserToDoRelation({ variables: { toDoId: parseInt(toDoId) } });

          // Aggiungi relazione creatore
          await addUserToDoRelation({ variables: { userId: currentUserId, toDoId: parseInt(toDoId), assigned: false } });

          // Aggiungi relazioni per utenti selezionati
          for (let i = 0; i < selectedUserFromLayer.length; i++) {
            await addUserToDoRelation({ variables: { userId: parseInt(selectedUserFromLayer[i].id), toDoId: parseInt(toDoId), assigned: true } });
          }

          // Aggiungi allegati
          if (contentType && elencoFileFromLayer.length > 0) {
            for (let i = 0; i < elencoFileFromLayer.length; i++) {
              await addAttachment({ variables: { name: elencoFileFromLayer[i].name, contentType: contentType.id, objectId: toDoId, attachment: JSON.stringify(elencoFileFromLayer[i]) } });
            }
          }

          alert("Nota aggiornata correttamente");
          handleCloseLayer();
          filterToDo(index);
        })
        .catch((error) => {
          console.error(error);
          alert("Errore durante l'aggiornamento");
        });
    }
  }, [usersList, contentType, index, filterToDo, handleCloseLayer, addToDo, updateToDo, deleteUserToDoRelation, addUserToDoRelation, addAttachment]);

  const onActive = useCallback((nextIndex) => {
    filterToDo(nextIndex);
    setIndex(nextIndex);
  }, [filterToDo]);

  const handleOpenNewToDo = useCallback(() => {
    setElencoFile([]);
    setElencoAllegati([]);
    setFormData({});
    setSelectedUser([]);
    setShowLayer(true);
  }, []);

  if (!sessionStorage.getItem("accessToken")) {
    return <Redirect to='/' />;
  }

  return (
    <Grommet theme={theme} themeMode="dark" className="font-link">
      <Box align="center" margin="small" height="94vh" overflow="hidden">
        <Box width="100%" overflow="hidden" aligns="center" pad="small" margin="10px">
          <Text color="#397aa3" size="large" weight="bold" alignSelf="start">TO DO LIST</Text>
          <Divider />
        </Box>
        <Box width="100%" overflow="auto" gap="small" height="100vh">
          <Tabs activeIndex={index} onActive={onActive}>
            <Tab title="TUTTI">
              <ToDoListContent
                elencoToDo={elencoToDo}
                expanded={expanded}
                onExpandChange={handleExpandChange}
                onCheck={handleCheck}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onAccordionClick={handleAccordionClick}
                elencoFile={elencoFile}
                width={width}
              />
            </Tab>
            <Tab title="ASSEGNATI">
              <ToDoListContent
                elencoToDo={elencoToDo}
                expanded={expanded}
                onExpandChange={handleExpandChange}
                onCheck={handleCheck}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onAccordionClick={handleAccordionClick}
                elencoFile={elencoFile}
                width={width}
              />
            </Tab>
            <Tab title="ARCHIVIATI">
              <ToDoListContent
                elencoToDo={elencoToDo}
                expanded={expanded}
                onExpandChange={handleExpandChange}
                onCheck={handleCheck}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onAccordionClick={handleAccordionClick}
                elencoFile={elencoFile}
                width={width}
              />
            </Tab>
          </Tabs>
        </Box>
        {showLayer && (
          <ToDoFormLayer
            initialFormData={formData}
            usersList={usersList}
            initialSelectedUser={selectedUser}
            contentType={contentType}
            onClose={handleCloseLayer}
            onSave={handleSave}
            elencoAllegatiProp={elencoAllegati}
          />
        )}
        <Fab
          onClick={handleOpenNewToDo}
          style={{
            margin: 0,
            top: 'auto',
            right: 30,
            bottom: 30,
            left: 'auto',
            position: 'fixed',
          }}
          color="primary"
          aria-label="add"
        >
          <AddIcon />
        </Fab>
      </Box>
    </Grommet>
  );
}

export default ToDoListMain;